import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { EnvironmentProviders, importProvidersFrom, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FUSE_CONFIG } from '@fuse/services/config/config.constants';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import {
	fuseLoadingInterceptor,
	FuseLoadingService,
} from '@fuse/services/loading';
import { FusePlatformService } from '@fuse/services/platform';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { FuseUtilsService } from '@fuse/services/utils';
import { appConfig } from 'app/core/config/app.config';

/**
 * Fuse provider — retained services only.
 * Theming is now handled by provideTheming() in app.config.ts.
 * Media watching is now handled by the signal-based Media service.
 */
export const provideFuse = (): Array<Provider | EnvironmentProviders> => {
	return [
		{
			provide: FUSE_CONFIG,
			useValue: appConfig,
		},

		importProvidersFrom(MatDialogModule),
		provideEnvironmentInitializer(() => inject(FuseConfirmationService)),

		provideHttpClient(withXhr(), withInterceptors([fuseLoadingInterceptor])),
		provideEnvironmentInitializer(() => inject(FuseLoadingService)),

		provideEnvironmentInitializer(() => inject(FusePlatformService)),
		provideEnvironmentInitializer(() => inject(FuseSplashScreenService)),
		provideEnvironmentInitializer(() => inject(FuseUtilsService)),
	];
};

